import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Writeoff API - Base definition
 *
 * This is the base API slice for the Writeoff service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see writeoffEndpoints.ts - Writeoff CRUD and worklist operations
 * @see documentEndpoints.ts - Document management (upload, download, delete)
 */
export const writeoffApi = createApi({
  reducerPath: 'writeoffApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.writeoffs),
  tagTypes: ['Writeoff', 'WriteoffWorklist', 'WriteoffDocument'],
  endpoints: () => ({}),
});
